import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=489c6f7d&scoped=true&"
import script from "./Webhooks.vue?vue&type=script&lang=js&"
export * from "./Webhooks.vue?vue&type=script&lang=js&"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=489c6f7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c6f7d",
  null
  
)

export default component.exports